import * as MutationTypes from "./mutation-types";

export const setRole = ({ commit }, role) => {
  commit(MutationTypes.SET_ROLE, role);
};

export const resetRole = ({ commit }) => {
  commit(MutationTypes.RESET_ROLE);
};
